var path = '/app/components/generateButtonCodeModal/generatebuttoncodemodal.html';
var html = "<div class=modal-header> <h3 class=modal-title id=modal-title>Generate Link Code</h3> </div> <div class=modal-body id=modal-body> <p>Copy and paste this button code snippet into your website to link to this product group page.</p> <div class=form-group> <textarea class=form-control id=service-update-description ng-model=ctrl.code rows=8></textarea> </div> </div> <div class=modal-footer> <button class=\"btn btn-default\" type=button ng-click=ctrl.cancel()>Close</button> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/generateButtonCodeModal/generatebuttoncodemodal.html
// module id = 1090
// module chunks = 0